'use client';

import { simpleContentSection } from '@stereoagency/sanity-schema';
import { SimpleContentSection as UISimpleContentSection } from '@stereoagency/ui';
import { BlockContent } from '../sanity/client';

type Props = typeof simpleContentSection.schema.simpleContentSection;

export default function SimpleContentSection({ variant, content }: Props) {
  return (
    <UISimpleContentSection variant={variant === 'medium' ? 'md' : 'default'}>
      <BlockContent value={content ?? []} />
    </UISimpleContentSection>
  );
}
